import { checkIfGtmIsBlocked } from '@src/quince-site-common/src/utils/checkIsGtmBlocked'
import initialiseDlProxy from '@src/quince-site-common/src/utils/dataLayer.utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackInternalEvent } from '@src/telemetry/track'

import mixpanelCl from '../../../telemetry/integrations/mixpanel'
import checkForWordInURL from '../utils/checkForWordInURL'
import { ANALYTIC_COOKIES } from '../utils/constants'
import eraseCookie from '../utils/eraseCookie'
import extractDomainFromURL from '../utils/extractDomainFromURL'
import extractQueryParamFromPageLocation from '../utils/extractQueryParamFromPageLocation'
import getCookie from '../utils/getCookie'
import getCurrentUser from '../utils/getCurrentUser'
import isBrowser from '../utils/isBrowser'
import setCookie from '../utils/setCookie'
import { setInLocalStorageWithExpiry } from '../utils/setInLocalStorageWithExpiry'
import { createLastBrandUserId, uniqueIdGenerator } from '../utils/getlb-user-id'

export default function initialize() {
  // Capturing user information in cookie.
  setCustomerDetailsInCookie()

  // Persisting Session information in cookies.
  createLastBrandUserId()
  captureCampaignParams()
  createNewSessionIfNeeded()
  // Extending session every 80 minutes
  setInterval(
    function () {
      createNewSessionIfNeeded()
    },
    80 * 60 * 1000,
  )
  initialiseDlProxy()
  checkIfGtmIsBlocked()
}

function captureCampaignParams() {
  let isUTMParamsPresent = false
  if (extractQueryParamFromPageLocation('utm_source')) {
    setCookie(ANALYTIC_COOKIES.UTM_SOURCE, extractQueryParamFromPageLocation('utm_source'), 120)
    eraseCookie(ANALYTIC_COOKIES.UTM_MEDIUM)
    eraseCookie(ANALYTIC_COOKIES.UTM_CONTENT)
    eraseCookie(ANALYTIC_COOKIES.UTM_TERM)
    eraseCookie(ANALYTIC_COOKIES.QCLID)
    isUTMParamsPresent = true
  }
  if (extractQueryParamFromPageLocation('utm_content')) {
    setCookie(ANALYTIC_COOKIES.UTM_CONTENT, extractQueryParamFromPageLocation('utm_content'), 120)
  }
  if (extractQueryParamFromPageLocation('utm_term')) {
    setCookie(ANALYTIC_COOKIES.UTM_TERM, extractQueryParamFromPageLocation('utm_term'), 120)
  }
  if (extractQueryParamFromPageLocation('utm_medium')) {
    setCookie(ANALYTIC_COOKIES.UTM_MEDIUM, extractQueryParamFromPageLocation('utm_medium'), 120)
  }
  if (extractQueryParamFromPageLocation('utm_campaign')) {
    setCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN, extractQueryParamFromPageLocation('utm_campaign'), 120)
  }
  if (extractQueryParamFromPageLocation('qclid')) {
    setCookie(ANALYTIC_COOKIES.QCLID, extractQueryParamFromPageLocation('qclid'), 120)
  }

  // Setting SEO referred in Campaign
  if (!isUTMParamsPresent) {
    captureSEOReferrerAsCampaign()
  }
}

function captureSEOReferrerAsCampaign() {
  const referrer = (isBrowser() && document.referrer) || ''
  const domain = extractDomainFromURL(referrer)
  if (
    !domain ||
    checkForWordInURL(referrer, 'apay-us.amazon') ||
    ['lastbrand', 'onequince', 'quince', 'localhost', 'myshopify', 'shopify', 'paypal', 'klarnapayments'].includes(
      domain,
    )
  ) {
    return
  }
  setCookie(ANALYTIC_COOKIES.UTM_SOURCE, domain, 120)
  setCookie(ANALYTIC_COOKIES.UTM_MEDIUM, 'organic', 120)
  eraseCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN)
  eraseCookie(ANALYTIC_COOKIES.UTM_CONTENT)
  eraseCookie(ANALYTIC_COOKIES.UTM_TERM)
  eraseCookie(ANALYTIC_COOKIES.QCLID)
}

function setCustomerDetailsInCookie() {
  const user = getCurrentUser()
  if (user?.email) {
    setCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, user.email)
    mixpanelCl.identify({ email: user.email, isTentativeEmail: false })
  }
}

export function createNewSessionIfNeeded() {
  if (!getCookie(ANALYTIC_COOKIES.SESSION_ID)) {
    console.info('Quince cookies : session id is not present')
    const sessionId = uniqueIdGenerator()
    console.info('Quince cookies : setting session id - ', sessionId)
    setCookie(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120)
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, sessionId, 120)
    trackInternalEvent(TELEMETRY_EVENT_NAMES.SESSION_CREATE, {
      sessionId,
    })
  } else {
    // If session is already present then extending session further by approx 2 hour
    console.info('Quince cookies : session id already present, extending by 2 hours')
    setCookie(ANALYTIC_COOKIES.SESSION_ID, getCookie(ANALYTIC_COOKIES.SESSION_ID), 120)
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, getCookie(ANALYTIC_COOKIES.SESSION_ID)!, 120)
  }
}
